import React, {useMemo, useRef} from "react";
import {CategoryScale, Chart as ChartJS, Legend, LinearScale, LineElement, PointElement, Title, Tooltip,} from 'chart.js';
import {Line} from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

/**
 * @param {Partial<import('react-chartjs-2').ChartProps>} props
 * @param {Function} formatDataLabel
 * @return {JSX.Element}
 * @constructor
 */
const LineChart = ({formatDataLabel, ...props}) => {
    /**@type {React.MutableRefObject<import("chart.js").Chart>}*/
    const chartRef = useRef(null);
    /**@type {import("chart.js").ChartOptions<"line">}*/
    const options = useMemo(() => ({
        responsive: true,
        maintainAspectRatio: false,
        ...props.options,
        plugins: {
            ...(props.options?.plugins ?? {}),
            tooltip: {
                ...(props.options?.plugins?.tooltip ?? {}),
                displayColors: false,
                titleFont: () => ({
                    size: 14,
                }),
                bodyFont: () => ({
                    size: 12,
                }),
                padding: () => 10,
                callbacks: {
                    label: (tooltipItem) => {
                        const data = tooltipItem.dataset.data[tooltipItem.label];
                        return (
                            `${
                                tooltipItem.dataset.label ?? ''
                            }: ${
                                tooltipItem.dataset.formatValue
                                    ? tooltipItem.dataset.formatValue(data)
                                    : tooltipItem.formattedValue
                            }`
                        )
                    },
                },
            },
            legend: {
                position: 'top',
            },
        },
    }), [props.options])


    return (
        <Line
            {...props}
            ref={chartRef}
            options={options}
            type={'line'}
        />
    );
}

export default LineChart;
